module.exports = __webpack_public_path__ + "static/media/card-big.d2868625.mp3";